exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button[data-v-7ddff1a4],.error-msg[data-v-7ddff1a4]{margin:16px}.container[data-v-7ddff1a4]{justify-content:center}.droparea[data-v-7ddff1a4]{width:100%;height:100%}#upload[data-v-7ddff1a4]{text-align:center;height:100%}.uploading[data-v-7ddff1a4]{width:100%;text-align:center}.uploading .circle.notch[data-v-7ddff1a4]{margin-bottom:12px;height:20px;width:22px}.uploading .progress-indicator[data-v-7ddff1a4]{margin-bottom:36px}.uploading .progress .label[data-v-7ddff1a4]{overflow:hidden;max-height:24px;word-break:break-all}.hidden[data-v-7ddff1a4]{visibility:hidden}", ""]);

// exports
